import { Navigate, Routes, Route } from 'react-router-dom';
import MainLayout from '@/layouts/MainLayout';
import { CasinoResultsPage, GamesPage, NotFoundPage, SessionUnavailablePage } from './routes';
import GameRoute from './GameRoute';

// NOTE: game routes establish their own launch-token session in useGameSession.
// Keep login protection separate until a login flow is wired into these routes.
export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/game-list" replace />} />
      <Route element={<MainLayout />}>
        <Route path="/game-list" element={<GamesPage />} />
      </Route>

      <Route path="/session-error" element={<SessionUnavailablePage />} />

      <Route path="/:gameSlug/history" element={<CasinoResultsPage />} />

      {/* Every game is resolved to its page component via GAME_REGISTRY in games/gameRegistry.ts */}
      <Route path="/:gameSlug" element={<GameRoute />} />

      {/* Not Found Page */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
